import { render, staticRenderFns } from "./artlist.vue?vue&type=template&id=dbbca710&scoped=true&"
import script from "./artlist.vue?vue&type=script&lang=js&"
export * from "./artlist.vue?vue&type=script&lang=js&"
import style0 from "./artlist.vue?vue&type=style&index=0&id=dbbca710&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbca710",
  null
  
)

export default component.exports